import { render } from "./rates.vue?vue&type=template&id=31d52e48&scoped=true"
import script from "./rates.vue?vue&type=script&lang=js"
export * from "./rates.vue?vue&type=script&lang=js"

import "./rates.vue?vue&type=style&index=0&id=31d52e48&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d52e48"]])

export default __exports__